import { render, staticRenderFns } from "./ReleaseOverviewManagerTable.vue?vue&type=template&id=7481f9c7&scoped=true&"
import script from "./ReleaseOverviewManagerTable.vue?vue&type=script&lang=js&"
export * from "./ReleaseOverviewManagerTable.vue?vue&type=script&lang=js&"
import style0 from "./ReleaseOverviewManagerTable.vue?vue&type=style&index=0&id=7481f9c7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7481f9c7",
  null
  
)

export default component.exports